import LogoFinal from '../components/assets/LogoFinal';
import { Button } from '../components';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

function LoginPage() {
  const { loginWithRedirect, getAccessTokenSilently, isAuthenticated } =
    useAuth0();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const performSilentLogin = async () => {
      try {
        await getAccessTokenSilently();
        console.log('User authenticated silently');
      } catch (e) {
        console.error('Silent authentication failed', e);
      } finally {
        setLoading(false);
      }
    };

    if (!isAuthenticated) {
      performSilentLogin();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  const handleLogin = async () => {
    try {
      await loginWithRedirect({
        authorizationParams: {
          prompt: 'select_account',
        },
      });
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="w-full h-full">
      <div className="flex flex-row flex-nowrap justify-center items-center h-screen">
        <div className="w-3/5 h-screen bg-login-bg bg-cover">
          <h3 className="absolute top-24 left-12   font-normal text-4xl text-tertiary-500">
            BUSINESS CONTINUITY
          </h3>
          <h3 className="absolute top-40 left-12   font-normal text-4xl text-tertiary-500">
            RISK QUANTIFICATION
          </h3>
          <h3 className="absolute top-100 left-12   font-bold text-4xl text-tertiary-500">
            SIMPLIFIED
          </h3>
        </div>
        <div className="w-2/5 bg-white flex flex-col flex-nowrap justify-center items-center h-screen">
          <LogoFinal className="mb-16" />
          <h3 className="  font-bold text-3xl text-black">GET STARTED</h3>
          <Button
            type="login"
            htmlType="submit"
            onClick={handleLogin}
            className="my-2"
          >
            {loading ? (
              <Spin
                indicator={<LoadingOutlined spin />}
                size="large"
                style={{ color: '#FFFFFF' }}
              />
            ) : (
              'LOGIN'
            )}
          </Button>

          <h3 className="absolute bottom-8   font-bold text-base text-black">
            MEOCONTINUITY.COM
          </h3>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
